import React from 'react';
import { ImportReferenceUploadTemplate } from 'themes/application/import-reference/pages';
import { observer } from 'mobx-react';
import { ImportReferenceUploadViewStore } from 'application/import-reference/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ImportReferenceUploadViewStore(rootStore), 'importReferenceUploadViewStore')
@observer
class ImportReferenceUpload extends React.Component {
    render() {
        return <ImportReferenceUploadTemplate {...this.props} />
    }
}

export default ImportReferenceUpload;